export default "__VITE_ASSET__DC___L27__"